import { NameDto } from 'api/Common/Types'

import { InstrumentDto } from './InstrumentDto'

export interface CorporateActionDto {
  corporateActionCapitalChange: null
  corporateActionDividend: null
  corporateActionEarningsRelease: null
  corporateActionMergerAcquisition: null
  corporateActionSharesOutstanding: null
  corporateActionType: NameDto
  corporateActionVotingRight: {
    votingRightsDate: string
    votingRightsDescription: null
    votingRightsPerShare: number
  }
  date: string
  details: Record<string, string>
  externalId: string
  id: string
  instrument: InstrumentDto
  isDeleted: boolean
  isExcluded: boolean
  isProcessed: boolean
  lastUpdatedAt: string
  notes: null | string
}

export enum CorporateActionFilterKey {
  Type = 'Type',

  brokerSymbol = 'Symbol',
  EventDate = 'Date',

  IsDeleted = 'IsDeleted',
  IsProcessed = 'IsProcessed',

  GrossDividendAmount = 'GrossDividendAmount',
}
